import { Button, Modal, Text } from "@marketplace/ui";
import { useAtomValue } from "jotai";
import { useResetAtom } from "jotai/utils";
import { useTranslation } from "react-i18next";

import { changePublishStatusModalAtom } from "../../atoms/product-list-page-atom";
import { usePutSetPublishStatusMutation } from "../../hooks/mutations/use-put-set-publish-status-mutation";

type ChangePublishStatusModalProps = {
  opened: boolean;
  onClose: () => void;
};

export const ChangePublishStatusModal = ({
  opened,
  onClose
}: ChangePublishStatusModalProps) => {
  const { t: tProduct } = useTranslation("product");
  const { t: tCommon } = useTranslation("common");
  const { productId, currentStatus, isPublish } = useAtomValue(
    changePublishStatusModalAtom
  );
  const resetModal = useResetAtom(changePublishStatusModalAtom);

  const { mutateAsync, isPending } = usePutSetPublishStatusMutation();
  const toPublishStatus = ["in_review", "draft", "rejected", "unpublish"];
  const targetAction =
    toPublishStatus.includes(currentStatus) || (currentStatus && !isPublish)
      ? "publish"
      : "unpublish";

  const handleClose = () => {
    resetModal();
    onClose();
  };

  const handleConfirm = async () => {
    if (!productId) return;

    await mutateAsync({
      productId,
      is_publish: targetAction === "publish" ? true : false
    });

    handleClose();
  };

  return (
    <Modal.Root
      opened={opened}
      onClose={handleClose}
      size={345}
      classNames={{
        header: "!p-6 !pb-0",
        body: "!p-6"
      }}
    >
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Body>
          <Text
            type="heading"
            size="xxs"
            weight="semibold"
            className="text-center text-fjord-grey-500 mb-1"
          >
            {tProduct(`changePublishStatusModal.${targetAction}.title`)}
          </Text>
          <Text
            type="paragraph"
            size="s"
            className="text-center text-fjord-grey-400 mb-6"
          >
            {tProduct(`changePublishStatusModal.${targetAction}.description`)}
          </Text>
          <div className="flex gap-x-[14px]">
            <Button variant="secondary" fullWidth onClick={handleClose}>
              {tCommon("no")}
            </Button>
            <Button
              variant="primary"
              fullWidth
              loading={isPending}
              onClick={handleConfirm}
            >
              {tCommon("yes")}
            </Button>
          </div>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
